import Vue from 'vue'
import Router from 'vue-router'
// 错误或找不到展示的页面
const error = () => import('@/components/common/error/error')
// 没权限页面
const permission = () => import('@/components/common/permission/permission')
// 登录
const login = () => import('@/components/login/login')

// 主框架
const mainLayout = () => import('@/components/main/layout')

// 大数据平台页面
const bigDataLayout = () => import('@/components/main/bigData/layout')
const bigDataHome = () => import('@/components/main/bigData/home')
const bigDataSearch = () => import('@/components/main/bigData/search')
const bigDataDetail = () => import('@/components/main/bigData/search/compontents/detail')
const searchDetail = () => import('@/components/main/bigData/search/details')

// 订单跟踪
const bigDataOrderDetail = () => import('@/components/main/bigData/order/detail')

Vue.use(Router)

export default new Router({
  linkActiveClass: 'focus', // 存在配置时显示的当前样式
  linkExactActiveClass: 'focus', // 精确配置时显示的当前样式
  routes: [
    { path: '', redirect: { name: 'login' } },
    { path: '/login', meta: {chTit: '登录', enTit: 'Login'}, name: 'login', component: login },
    {
      path: '/main',
      component: mainLayout,
      children: [
        {
          path: 'bigData',
          component: bigDataLayout,
          children: [
            { path: 'home', meta: {chTitle: '大数据首页', enTitle: 'Home'}, name: 'bigDataHome', component: bigDataHome },
            { path: 'search', meta: {chTitle: '大数据搜索页', enTitle: 'Search'}, name: 'bigDataSearch', component: bigDataSearch },
            { path: 'Detail', meta: {chTitle: '详情页', enTitle: 'Detail'}, name: 'bigDataDetail', component: bigDataDetail },
            { path: 'searchDetail', meta: {chTitle: '详情页', enTitle: 'Detail'}, name: 'searchDetail', component: searchDetail },
            { path: 'order/detail', meta: {chTitle: '订单详情', enTitle: 'Detail'}, name: 'bigDataOrderDetail', component: bigDataOrderDetail }
          ]
        }
      ]
    },
    { path: '/error', meta: {chTitle: '错误', enTitle: 'Error'}, name: 'error', component: error },
    { path: '/permission', meta: {chTitle: '无权限', enTitle: 'No Permission'}, name: 'permission', component: permission },
    { path: '*', redirect: { name: 'login' } }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js